
/**
 * TODO: Documentation
 * `Tracking` - Wrapper component used to initiate our tracking service.
 */
import ComponentInitializeDispatcher from '@owc-utils/Mixins/ComponentInitializeDispatcher';
import initializeTracking from './TrackingUtils';
import { TrackingComponent } from './Tracking';
import OwcDataComponent from '@owc-utils/Mixins/OwcDataComponent';

let isInitialized = false;

export default (ComponentInitializeDispatcher as TrackingComponent).extend({
  name: 'owc-tracking',
  mixins: [OwcDataComponent],
  watch: {
    componentData(data) {
      if (!isInitialized) {
        const dataIsAvailable = data && Object.keys(data).length > 0;

        if (dataIsAvailable) {
          initializeTracking({ ...data });

          isInitialized = true;
        }
      }
    },
  },
});
